


export const config = {
    prapp: {
        basURL:process.env.REACT_APP_API_URL
     }
}

// basURL:'http://is-s2357:3000'
// basURL:'http://localhost:5000'
// basURL:'https://priservice.azurewebsites.net'